import sample_1 from './olympSuperSlim.jpg';

export const olympSuperSlimImpressions = {
    sample_1,
};
